<template>
  <OLink
    v-if="instagramUsername"
    target="_blank"
    :href="`https://instagram.com/${instagramUsername}`"
    class="flex items-center justify-between py-3 pl-5 pr-3 bg-[#f7f8fb] rounded-md"
  >
    <div class="text-xl font-semibold leading-24 text-primary-200">
      {{ user.name }}
    </div>
    <OButton pure class="flex items-center bg-o-blue text-sm leading-18 font-semibold text-white rounded-md p-2 pl-3">
      <OIcon icon="article/instagram-white" svg-class="w-4 h-4 mr-3" />
      TAKİP ET
    </OButton>
  </OLink>
</template>

<script>
import { computed } from '@nuxtjs/composition-api';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { OButton, OLink, OIcon } from '~/modules/common/components/ui';

export default {
  components: { OButton, OLink, OIcon },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  setup({ user }) {
    const instagramUsername = computed(() => user.instagramUsername);
    const userAvatarUrl = getImageUrl(user?.avatar, { standard: true });
    return {
      userAvatarUrl,
      instagramUsername,
    };
  },
};
</script>
